(function() {
'use strict';

angular
    .module('TR')
    .service('flightSearchValidator', flightSearchValidator);

function flightSearchValidator(resourceService, dateUtil, occupancyService) {
    const service = {
        validate
    };

    function validate(isHoliday, destination, destinationAirport, departureAirports, departureDate, returnDate, outboundDates, cabin, occupancy, oneWayOnly) {
        const errors = [];

        if (isHoliday) {
            if (_.isEmpty(destination)) {
                errors.push(resourceService.get('SELECTDESTINATION'));
            } else {
                if (!destination.HolidayEnabled) {
                    errors.push(String.format(resourceService.get('NOTHOLIDAYENABLED'), destination.Title));
                }

                if (!destination.Searchable) {
                    errors.push(String.format(resourceService.get('NONSEARCHABLE'), destination.Title));
                }
            }

            if (cabin < 1) {
                errors.push(resourceService.get('SELECTFLIGHTCLASS'));
            }
        } else if (_.isEmpty(destinationAirport)) {
            errors.push(resourceService.get('SELECTDESTINATIONAIRPORT'));
        }

        if (departureAirports == null ||
            departureAirports.length === 0) {
            errors.push(resourceService.get('SELECTDEPARTUREAIRPORT'));
        }

        let destinationCodes = isHoliday ? destination && destination.DestinationAirports : destinationAirport && destinationAirport.Code;
        if (destinationCodes && departureAirports) {
            destinationCodes = destinationCodes.split(',');

            const destinationAndDepartureAreSame = _.some(destinationCodes, dest => _.includes(departureAirports, dest));
            if (destinationAndDepartureAreSame) {
                errors.push(resourceService.get('DEPARTUREANDDESTINATIONAIRPORTSTHESAME'));
            }
        }

        if (departureDate == null) {
            errors.push(resourceService.get('SELECTDEPARTUREDATE'));
        } else {
            if (TRPCONFIG.Domain.HolidaysSearchOffsetDate !== 0 && !dateUtil.atLeastOneDayInTheFuture(departureDate)) {
                errors.push(resourceService.get('DEPARTUREDATEMUSTBEFUTURE'));
            }
            if (outboundDates &&
                Object.keys(outboundDates).length > 0 &&
                outboundDates[dateUtil.format(departureDate, 'yyyy-MM-dd')] === undefined) {
                errors.push(resourceService.get('DEPARTUREDATENOTAVAILABLE'));
            }
        }

        if (returnDate == null && !oneWayOnly) {
            errors.push(resourceService.get('SELECTRETURNDATE'));
        } else if (returnDate <= departureDate && !oneWayOnly) {
            errors.push(resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
        }

        if (occupancyService.moreInfantsThanAdults()) {
            errors.push(resourceService.get('TOOMANYINFANTS'));
        }

        if (occupancyService.getNumberOfNonInfantPassengers() > 12) {
            errors.push(String.format(decodeURI(resourceService.get('TOOMANYPASSENGERS')), `${TRPCONFIG.DesktopUrlRoot}/Help/Groupbookings.aspx`, resourceService.get('TELEPHONENUMBER')));
        }

        if (!occupancyService.childAgesPopulated(occupancy)) {
            errors.push(resourceService.get('CHILDAGESERROR'));
        }

        return errors;
    }

    return service;
}
})();
